import { Image, Tag } from "antd";
import { Link } from "react-router-dom";
import { ShopOutlined } from "@ant-design/icons";
import routes from "../../utils/routes.js";

const stopRowClick = (e) => e.stopPropagation();

// Ant Design Table dataIndex -> Shop entity field. Only entries here are sortable.
// Nested fields (e.g. shopOfficer.name) intentionally excluded — they require
// the backend @Query to be reviewed first.
const SORT_FIELD_MAP = {
  id: "id",
  shopName: "name",
  shopEmail: "email",
  subscriptionType: "subscriptionType",
};

const SUBSCRIPTION_TAG_COLOR = {
  REVENUECAT: "green",
  OVERRIDE: "blue",
  PADDLE: "red",
};

const renderText = (value) => value || "-";

const ShopColumns = () => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 70,
    sorter: true,
    defaultSortOrder: "descend",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Görsel",
    dataIndex: "shopImageUrl",
    key: "shopImageUrl",
    width: 80,
    render: (value) =>
      value ? (
        <span onClick={stopRowClick} style={{ display: "inline-block" }}>
          <Image width={50} src={value} />
        </span>
      ) : (
        <ShopOutlined style={{ fontSize: 22, color: "#d9d9d9" }} />
      ),
  },
  {
    title: "Mağaza Adı",
    dataIndex: "shopName",
    key: "shopName",
    width: 180,
    sorter: true,
    render: renderText,
  },
  {
    title: "Sektör",
    dataIndex: "shopSectorName",
    key: "shopSectorName",
    width: 150,
    render: (value) => (value ? <Tag>{value}</Tag> : "-"),
  },
  {
    title: "Yetkili Adı",
    dataIndex: "shopOfficerName",
    key: "shopOfficerName",
    width: 150,
    render: renderText,
  },
  {
    title: "Yetkili Telefonu",
    dataIndex: "shopOfficerPhoneNumber",
    key: "shopOfficerPhoneNumber",
    width: 140,
    render: renderText,
  },
  {
    title: "Yetkili E-posta",
    dataIndex: "shopOfficerEmail",
    key: "shopOfficerEmail",
    width: 220,
    ellipsis: true,
    render: renderText,
  },
  {
    title: "Mağaza E-posta",
    dataIndex: "shopEmail",
    key: "shopEmail",
    sorter: true,
    width: 220,
    ellipsis: true,
    render: renderText,
  },
  {
    title: "Adres",
    dataIndex: "shopAddress",
    key: "shopAddress",
    width: 240,
    ellipsis: true,
    render: renderText,
  },
  {
    title: "Abonelik",
    dataIndex: "subscriptionType",
    key: "subscriptionType",
    width: 120,
    sorter: true,
    render: (value) => {
      if (!value) return <Tag>Yok</Tag>;
      return (
        <Tag color={SUBSCRIPTION_TAG_COLOR[value.name] ?? "default"}>
          {value.description}
        </Tag>
      );
    },
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    fixed: "right",
    width: 100,
    render: (_, record) => (
      <Link
        to={`${routes.shopDetails}/${record.id}`}
        onClick={stopRowClick}
      >
        Detaylar
      </Link>
    ),
  },
];
export { ShopColumns, SORT_FIELD_MAP };
